import { ProcedureId } from '@/Domain/Procedures'
import { ProcedureInternalId } from './ProcedureInternalId'
import { MadeiristaId } from './MadeiristaId'
import { BatchInternalId } from './BatchInternalId'

export class GeneralDocumentationData {
  private _procedureCode: ProcedureId
  private _procedureInternalid: ProcedureInternalId
  private _madeiristaId: MadeiristaId
  private _batchInternalId: BatchInternalId

  constructor (
    procedureCode: ProcedureId,
    procedureInternalid: ProcedureInternalId,
    batchInternalId: BatchInternalId,
    madeiristaId: MadeiristaId
  ) {
    this._procedureCode = procedureCode
    this._procedureInternalid = procedureInternalid
    this._batchInternalId = batchInternalId
    this._madeiristaId = madeiristaId
  }

  procedureCode (): string {
    return this._procedureCode.id
  }

  procedureId (): number {
    return this._procedureInternalid.value()
  }

  madeiristaId (): number {
    return this._madeiristaId.value()
  }

  batchId (): number {
    return this._batchInternalId.value()
  }
}
